import jwtDecode from 'jwt-decode'
import { API_JWT_REFRESH_TOKEN_NAME, API_JWT_TOKEN_IAT, API_JWT_TOKEN_NAME, APP_USER_NAME } from '../middleware/api'
import StorageProviderFactory from '../managers/storage_provider_factory'
import { __isEnvDev, APP_USER, SESSION_APP_CONTEXT, STORAGE_TYPE_LOCAL } from '../config'

const TOKEN_REFRESH_FREQ = 60 * 10

export function isTokenExpired() {
  const token = StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem(API_JWT_TOKEN_NAME)
  if (token) {
    const decoded = jwtDecode(token)
    const dteSecNow = Math.round(Date.now() / 1000)
    return decoded.exp <= dteSecNow
  }
  return true
}

export function isTokenExist() {
  const token = StorageProviderFactory.create(STORAGE_TYPE_LOCAL).getItem(API_JWT_TOKEN_NAME)
  return !!token
}

export function isTimeToRefreshToken() {
  const storageProvider = StorageProviderFactory.create(STORAGE_TYPE_LOCAL)
  const token = storageProvider.getItem(API_JWT_TOKEN_NAME)

  if (!token) {
    if (__isEnvDev()) {
      console.log('Token not found')
    }
    return false
  }
  const decoded = jwtDecode(token)
  const dteSecNow = Math.round(Date.now() / 1000)
  if (decoded.exp - dteSecNow <= TOKEN_REFRESH_FREQ) {
    if (__isEnvDev()) {
      console.log('Time to renew access token')
    }
    return true
  }
  return false
}

export const clearSession = () => {
  const arr = [
    API_JWT_TOKEN_NAME,
    API_JWT_TOKEN_IAT,
    API_JWT_REFRESH_TOKEN_NAME,
    APP_USER_NAME,
    SESSION_APP_CONTEXT,
    APP_USER,
  ]
  arr.forEach((name) => StorageProviderFactory.create(STORAGE_TYPE_LOCAL).removeItem(name))
}
